import React from "react";
import { Project } from "../../services/projectsApi";
import { AreaLite, monitorableMembers } from "../../services/projectMonitoring";

// "Your projects" grid on Monitor Areas: each card shows how many of the
// project's monitorable (custom-polygon) members are live, with bulk
// Enable/Disable-all actions. daisyUI styling to match the host page.
const ProjectMonitorCards: React.FC<{
  projects: Project[];
  areas: AreaLite[];
  monitoredSet: Set<string>;
  busy: boolean;
  onOpen: (p: Project) => void;
  onDelete: (id: string) => void;
  /** Hide delete and enable/disable (support view or a viewer). */
  readOnly?: boolean;
  onEnableAll: (p: Project) => void;
  onRequestDisableAll: (p: Project) => void;
}> = ({ projects, areas, monitoredSet, busy, onOpen, onDelete, onEnableAll, onRequestDisableAll, readOnly = false }) => (
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
    {projects.map((p) => {
      const members = monitorableMembers(p.areaIds, areas, monitoredSet);
      const monN = members.filter((m) => m.monitored).length;
      return (
        <div key={p.id} className="rounded-xl border border-base-300 bg-base-100 p-3 shadow-sm">
          <div className="flex items-start justify-between gap-2">
            <button
              className="text-left text-sm font-semibold hover:text-primary"
              onClick={() => onOpen(p)}
            >
              {p.name}
              <span className="ml-1 text-xs font-normal text-base-content/50">
                · {p.areaIds.length}
              </span>
            </button>
            {!readOnly && (
              <button
                className="btn btn-ghost btn-xs btn-circle text-base-content/40 hover:text-error"
                title="Delete project"
                onClick={() => onDelete(p.id)}
              >
                ✕
              </button>
            )}
          </div>
          <p className="mt-0.5 text-xs text-base-content/60">
            {members.length ? `${monN}/${members.length} monitored` : "no monitorable areas"}
          </p>
          {members.length > 0 && !readOnly && (
            <div className="mt-2 flex gap-2">
              <button
                className="btn btn-xs btn-outline"
                disabled={busy || monN === members.length}
                onClick={() => onEnableAll(p)}
              >
                Enable all
              </button>
              <button
                className="btn btn-xs btn-outline"
                disabled={busy || monN === 0}
                onClick={() => onRequestDisableAll(p)}
              >
                Disable all
              </button>
            </div>
          )}
        </div>
      );
    })}
  </div>
);

export default ProjectMonitorCards;
